import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeverityBreakdown } from '../../../../models/patch-management.models';

@Component({
  selector: 'app-severity-compliance-bars',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './severity-compliance-bars.component.html',
  styleUrls: ['./severity-compliance-bars.component.scss'],
})
export class SeverityComplianceBarsComponent {
  @Input({ required: true }) severities: SeverityBreakdown[] = [];
  @Input() activeSeverity: string | null = null;
  @Output() severitySelect = new EventEmitter<string>();
}
